import {config} from '../config';

const getIsManualActivationEnabledByType = (deviceType) => {
    const deviceTypeList = config.data.manualActivation;

    return deviceTypeList?.some((item) => item === deviceType);
};

export default {
    getIsManualActivationEnabled: (deviceType) => getIsManualActivationEnabledByType(deviceType),
};
